import { render, staticRenderFns } from "./DonationPage.vue?vue&type=template&id=430b60df&scoped=true&"
import script from "./DonationPage.vue?vue&type=script&lang=js&"
export * from "./DonationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430b60df",
  null
  
)

export default component.exports